var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        [
          _c("app-fields-edit", {
            attrs: {
              line: _vm.line,
              title: _vm.title,
              "new-item-constructor": _vm.newItemConstructor,
            },
            scopedSlots: _vm._u([
              {
                key: "field-options",
                fn: function (slotProps) {
                  return [
                    _c(
                      "w-row",
                      [
                        _c(
                          "w-col",
                          { attrs: { xs: "6" } },
                          [
                            _c("w-input-number", {
                              attrs: { label: _vm.$ct("position"), fancy: "" },
                              model: {
                                value: slotProps.field.Position,
                                callback: function ($$v) {
                                  _vm.$set(slotProps.field, "Position", $$v)
                                },
                                expression: "slotProps.field.Position",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "w-col",
                          { attrs: { xs: "6" } },
                          [
                            _c("w-input-number", {
                              attrs: { label: _vm.$ct("width"), fancy: "" },
                              model: {
                                value: slotProps.field.Width,
                                callback: function ($$v) {
                                  _vm.$set(slotProps.field, "Width", $$v)
                                },
                                expression: "slotProps.field.Width",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }